<template>
    <div class="intro-panel">
        <div class="intro-panel__logo">
            <img src="@/assets/images/chatbot/robot_avatar.png" />
        </div>
        <div class="intro-panel__text-content">
            <span class="intro-panel__header" v-html="getIntroTitle"></span>
            <span class="intro-panel__description" v-html="$t('Chatbot.intro_description')"></span>
            <TotemButton
                class="intro-panel__start-button"
                size="medium"
                color="primary"
                @click="openNewChatSessionIfNoHistory"
                :label="$t('Chatbot.start_chatting')"
            />
            <span v-html="getSupportNotification" class="intro-panel__customer-support-notification"></span>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'IntroPanel',
        methods: {
            async openNewChatSessionIfNoHistory () {
                if (this.isThereChatSessions && !this.isThereChatHistory) {
                    this.$emit('create-suggestion-buttons')
                } else if (!this.isThereChatSessions) {
                    this.$emit('open-new-chat-session')
                }
                this.$store.dispatch('ChatBot/setIntroWatched', true)
            }
        },
        computed: {
            ...mapGetters({
                chatSessions: 'ChatBot/getChatSessions',
                chatHistory: 'ChatBot/getChatHistory'
            }),
            getIntroTitle () {
                return this.$t('Chatbot.intro_title')
            },
            getSupportNotification () {
                return this.$t('Chatbot.customer_support_notification', { icon: this.getCustomerSupportIcon })
            },
            getCustomerSupportIcon () {
                const iconPath = require('@/assets/images/chatbot/customer_support_chat_icon.png')
                return `<img style="position: relative; top: 7px;" class="intro-panel__customer-support-icon" src="${iconPath}" />`
            },
            isThereChatSessions () {
                return this.chatSessions && this.chatSessions.length > 0
            },
            isThereChatHistory () {
                if (this.chatHistory === null) {
                    return false
                }
                return this.chatHistory.length > 0
            }
        }
    }
</script>

<style lang="scss" scoped>
    .intro-panel {
        border: 0;
        width: 500px;
        height: 679px;
        background-color: $alabaster;
        opacity: 1;
        border-radius: 0px 0px 10px 10px;
        font-family: Quicksand-Regular;
        overflow: auto;
        display: flex;
        justify-content: center;
        flex-direction: column;
        overflow: auto;

        [class="mobile_sm"] & {
            height: calc(100vh - 75px);
            width: 100%;
        }

        &__logo {
            display: flex;
            justify-content: center;
        }

        &__text-content {
            display: flex;
            flex-direction: column;
            padding: 30px;
            gap: 30px;
            align-items: center;
            text-align: center;
        }

        &__header {
            font-family: 'Quicksand-Regular';
            font-size: 2.2rem;
        }

        &__description {
            font-size: 1.6rem;
            font-family: Nunito-Regular;
        }

        &__start-button {
            width: 200px !important;
            margin: 0 auto !important;
        }

        &__customer-support-notification {
            font-style: italic;
            font-family: Nunito-Regular;
        }
    }
</style>
